import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

import { Card } from '../Card/Card';

export const CardsListSkeleton = ({ cardCount = 3, cardRows = 1 }: { cardCount?: number; cardRows?: number }) => {
  return (
    <>
      {Array.from({ length: cardCount }).map((_, index) => (
        <Box
          key={index}
          sx={{
            mb: 2,
          }}
        >
          <Card key={index} title={<Skeleton variant="text" width="200px" />}>
            {Array.from({ length: cardRows }).map((_, index) => (
              <Box
                key={index}
                sx={{
                  mb: 2,
                }}
              >
                <Skeleton variant="rectangular" />
              </Box>
            ))}
          </Card>
        </Box>
      ))}
    </>
  );
};
